import MixpanelService from "@/scripts/analytics/mixpanel.js";

const pendingSocialAuthStorageKey = 'uxfolio.pendingSocialAuthTracking';
const pendingSocialAuthTtlMs = 10 * 60 * 1000;

const getCurrentPagePath = () => `${window.location.pathname}${window.location.search}${window.location.hash}`;

const isPrerendering = () => Boolean(window.__UXFOLIO_PRERENDER__);

const getPendingSocialAuth = () => {
    try {
        const pendingAuth = JSON.parse(window.sessionStorage.getItem(pendingSocialAuthStorageKey) || 'null');

        if (!pendingAuth || Date.now() - pendingAuth.createdAt > pendingSocialAuthTtlMs) {
            clearPendingSocialAuthTracking();
            return null;
        }

        return pendingAuth;
    } catch (error) {
        clearPendingSocialAuthTracking();
        return null;
    }
};

export function trackAuthEvent(eventName, properties = {}) {
    if (isPrerendering()) {
        return Promise.resolve();
    }

    return MixpanelService.track(eventName, {
        event_group: MixpanelService.MixpanelEventGroups.USER_LIFECYCLE,
        page_path: getCurrentPagePath(),
        ...properties,
    }).catch(() => {});
}

export function clearPendingSocialAuthTracking() {
    window.sessionStorage.removeItem(pendingSocialAuthStorageKey);
}

export function setPendingSocialAuthTracking(flow, type) {
    window.sessionStorage.setItem(pendingSocialAuthStorageKey, JSON.stringify({
        flow,
        type,
        createdAt: Date.now(),
    }));
}

export async function trackPendingSocialAuthCompletion({user, newUserCreated = false} = {}) {
    const pendingAuth = getPendingSocialAuth();

    if (!pendingAuth || !user?._id || !pendingAuth.type) {
        return;
    }

    MixpanelService.identify(user._id);
    MixpanelService.setUser(user);

    const commonProperties = {
        auth_page: pendingAuth.flow,
        type: pendingAuth.type,
    };

    if (pendingAuth.flow === 'signup' && newUserCreated) {
        await trackAuthEvent('SIGN_UP_COMPLETED', commonProperties);
        clearPendingSocialAuthTracking();
        return;
    }

    await trackAuthEvent('LOGGED_IN', commonProperties);
    clearPendingSocialAuthTracking();
}
